import { Flex } from 'antd';
import Icon from '@ant-design/icons';
import Info from '@/assets/icons/info-circle.svg?react';
import Warning from '@/assets/icons/warning.svg?react';
import styles from './info-component.module.scss';

export type InfoComponentProps = {
  text: string;
  type?: 'info' | 'warning';
};

export function InfoComponent({ text, type = 'info' }: InfoComponentProps) {
  const IconComponent = type === 'warning' ? Warning : Info;
  const iconClass = type === 'warning' ? styles.warningIcon : '';

  return (
    <Flex gap={10} className={styles.infoComponent}>
      <Icon
        className={`${styles.infoComponentIcon} ${iconClass}`}
        component={() => <IconComponent width={16} height={16} />}
      />
      <p>{text}</p>
    </Flex>
  );
}
